<template>
    <div :class="$style['no-result']" :style="style" ref="noResult">
        <div :class="$style['no-result__title']" v-html="currentType.caption">Попробуйте изменить условия поиска</div>
        <div :class="$style['no-result__description']" v-if="currentType.description">
            {{ currentType.description }}
        </div>

        <div :class="$style['no-result__button']" v-if="currentType.button">
            <button :class="$style['no-result__button-reset']" @click="$emit('resetFilter')">Сбросить фильтры</button>
        </div>
    </div>
</template>

<script>
    import Button from '../Button/Button';

    export default {
        components: {
            Button
        },

        props: ['type'],

        data: () => ({
            style: {},
            isMobile: window.innerWidth < 960,
            types: {
                base: {
                    caption: "Попробуйте изменить условия поиска",
                    description: "Для расчёта ежемесячного платежа подвигайте ползунки в фильтрах",
                    button: true
                },
                price: {
                    caption: "Попробуйте изменить стоимость квартиры",
                    description: "Для расчёта ежемесячного платежа подвигайте ползунок со стоимостью квартиры",
                    button: true
                },
                pay: {
                    caption: "Измените первый взнос",
                    description: "Для расчёта ежемесячного платежа подвигайте ползунок с первым взносом",
                    button: true
                },
                largePay: {
                    caption: "Первый взнос не может быть больше стоимости квартиры",
                    description: "Для расчёта ежемесячного платежа подвигайте ползунок с первым взносом или стоимостью квартиры",
                    button: true
                },
                smallPay: {
                    caption: "Первый взнос слишком маленький",
                    description: "Для расчёта ежемесячного платежа подвигайте ползунок с первым взносом",
                    button: true
                }
            }
        }),

        computed: {
            currentType() {
                return this.types[this.type] || this.types.base;
            }
        },

        methods: {
            calcHeight() {
                if (!this.filterEl || !this.tabEl) {
                    this.style = {};

                    return false;
                }

                const marginBottomTab = Number(window.getComputedStyle(this.tabEl).marginBottom.slice(0, -2));

                return `${this.filterEl.offsetHeight - (this.tabEl.offsetHeight + marginBottomTab)}px`;
            },

            initElements() {
                this.filterEl = document.querySelector('.j-filter-calc-content');
                this.tabEl = document.querySelector('.j-mortgage-calc-content-tabs');
            },

            resize() {
                this.isMobile = window.innerWidth < 960;

                if (this.isMobile) {
                    this.style = {};
                } else {
                    this.style = {
                        height: this.calcHeight()
                    };
                }
            }
        },

        mounted() {
            this.initElements();

            if (!this.isMobile) {
                this.style = {
                    height: this.calcHeight()
                };
            }

            window.addEventListener('resize', this.resize);
        },

        destroyed() {
            window.removeEventListener('resize', this.resize);
        }
    }
</script>

<style lang="scss" module>
    @import "./NoResult";
</style>
